import React from "react";
import { RefundsSubSection } from "../../RefundsSubSection/RefundsSubSection";
import { EnableLutSwitch } from "../../EnableLutModal/modules/EnableLutSwitch/EnableLutSwitch";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { DocumentUploadedNote } from "../../EnableLutModal/modules/DocumentUploadedNote/DocumentUploadedNote";
import { RequestVerificationStripe } from "../../SubSectionWrapper/modules/RequestVerificationStripe/RequestVerificationStripe";
import { CreditCardSubSection } from "../modules/CreditCardSubSection/CreditCardSubSection";

export const PAYMENT_OPTION_KEYS = {
  EMI: "emi",
  NO_COST_EMI: "no_cost_emi",
  CUSTOMER_REFUND: "customer_refund",
  INTERNATIONAL_PAYMENT: "international_payment",
  LUT: "lut",
  CREDIT_CARD: "credit_cards",
  AMEX_CARD: "amex_cards",
  DINERS_CARD: "diner_cards",
};
export const PAYMENT_OPTIONS_CONFIG = [
  {
    title: "EMI Customer Payments",
    description:
      "Allow customers to split their payments into manageable monthly instalments. **Standard 4-5% rate applicable**.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.EMI,
        title: "Enable EMI payments",
        description:
          "Toggle on to start accepting EMI payments from customers.",
      },
    ],
  },
  {
    title: "No-cost EMI Customer Payments",
    description:
      "Offer EMI plans with zero interest or fees, a cost-effective payment option. **Standard 4-5% rate applicable**.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.NO_COST_EMI,
        title: "Enable No-cost EMI payments",
        description:
          "Toggle on to start accepting zero interest EMI payments from customers.",
      },
    ],
  },
  {
    title: "Customer Transaction Refunds",
    description:
      "Easily process refunds to ensure customer satisfaction with smooth transactions.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.CUSTOMER_REFUND,
        title: "Enable Refunds",
        description:
          "Toggle on to be able to process customer transaction refunds.",
        customRightJSX: <RefundsSubSection />,
        classes: { subSectionTextMainWrapperEnabledStyle: "d-none" },
      },
    ],
  },
  {
    title: "International Customer Payments",
    description:
      "Accept payments from international customers and expand globally.",
    subSectionConfig: [
      {
        key: PAYMENT_OPTION_KEYS.INTERNATIONAL_PAYMENT,
        title: "Collect international payments",
        description:
          "Toggle on to start accepting payments from international customers.",
      },
      {
        key: PAYMENT_OPTION_KEYS.LUT,
        title: "Exempt customers from GST",
        description:
          "Provide the GST certificate and Letter of Undertaking to disable GST application for international customers.",
        customRightJSX: <EnableLutSwitch />,
        lockedStatesArr: [FEATURE_STATUS.PLAN_LOCKED],
        customFooter: (
          <DocumentUploadedNote text="Documents have been uploaded successfully. We’ll notify you once it has been activated." />
        ),
      },
    ],
  },
  {
    title: "Accept Credit Card Payments",
    description:
      "Allow customers to pay using their credit cards for added convenience and higher-value purchases.",
    subSection: <CreditCardSubSection />,
  },
];

export const CreditCardSubSectionConfig = {
  CREDIT_CARD: {
    key: PAYMENT_OPTION_KEYS.CREDIT_CARD,
    title: "Enable Credit Card Payments",
    description:
      "Toggle on to allow your customers to pay using their credit cards.",
  },

  AMEX_CARD: {
    key: PAYMENT_OPTION_KEYS.AMEX_CARD,
    title: "Accept AMEX Cards",
    lockedStatesArr: [FEATURE_STATUS.PLAN_LOCKED],
    description:
      "Toggle on to start accepting AMEX Credit Card from your customers",
    customFooter: (
      <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
        <RequestVerificationStripe
          config={{ key: PAYMENT_OPTION_KEYS.AMEX_CARD }}
        />
      </div>
    ),
  },
  DINER_CARD: {
    key: PAYMENT_OPTION_KEYS.DINERS_CARD,
    title: "Accept Diners Cards",
    lockedStatesArr: [FEATURE_STATUS.PLAN_LOCKED],
    description:
      "Toggle on to start accepting Diners Credit Card from your customers",
    customFooter: (
      <div className="tw-flex tw-flex-col tw-w-[90%] tw-mx-5 md:tw-mx-8 tw-mb-6 tw-mt-2 md:tw-mt-[-1.5rem]">
        <RequestVerificationStripe
          config={{ key: PAYMENT_OPTION_KEYS.DINERS_CARD }}
        />
      </div>
    ),
  },
};

export const PAYMENT_OPTIONS_SECTION_KEY = "payment_options";

export const GATEWAY_NUMBER_KEYS = {
  RAZORPAY: 1,
  STRIPE: 2,
  PAYTM: 3,
  CASH: 4,
  CASHFREE: 5,
  PHONEPE: 6,
  JUSPAY: 7,
  NEW_JUSPAY: 8,
  PAYPAL: 9,
  TAZAPAY: 10,
  BAJAJ_FINANCE: 11,
};

export const GATEWAY_NUMBER_STRING = {
  [GATEWAY_NUMBER_KEYS.RAZORPAY]: "Razorpay",
  [GATEWAY_NUMBER_KEYS.STRIPE]: "Stripe",
  [GATEWAY_NUMBER_KEYS.PAYTM]: "Paytm",
  [GATEWAY_NUMBER_KEYS.CASH]: "Cash",
  [GATEWAY_NUMBER_KEYS.CASHFREE]: "Cashfree",
  [GATEWAY_NUMBER_KEYS.PHONEPE]: "Phonepe",
  [GATEWAY_NUMBER_KEYS.JUSPAY]: "Juspay",
  [GATEWAY_NUMBER_KEYS.NEW_JUSPAY]: "New Juspay",
  [GATEWAY_NUMBER_KEYS.PAYPAL]: "Paypal",
  [GATEWAY_NUMBER_KEYS.TAZAPAY]: "Tazapay",
  [GATEWAY_NUMBER_KEYS.BAJAJ_FINANCE]: "Bajaj Finance",
};
